import {Box, IconButton, LinearProgress, Menu, Stack, Tooltip} from "@mui/material";
import {Download, HighQuality, RestartAlt, Code, Description, YouTube} from "@mui/icons-material";
import HelpIcon from '@mui/icons-material/Help';
import React, {useCallback, useState} from "react";
import MhdSelect from "../atomicComponents/MhdSelect";
import {resolutionChoices} from "../../utils/choices";
import {useTheme} from "@mui/material/styles";

import {downloadImage, setAndUpdate, downloadData} from "../../utils/helpers";
import {hasAsciiTable, toolExtensionCoupling, toolTutorialLinks} from "../../utils/globals";


const PlotOptionsBar = ({meta, loading, error, data, mods, update, setter, tool, resetDefaults}) => {
  const theme = useTheme()
  const [resolutionAnchor, setResolutionAnchor] = useState(null);
  const [awaitingApi, setAwaitingApi] = useState(false);

  return (
    <Box width={'100%'} sx={{justifyContent: 'center'}}>
      <Menu
        anchorEl={resolutionAnchor}
        open={Boolean(resolutionAnchor)}
        onClose={() => setResolutionAnchor(null)}
        PaperProps={{
          sx: {
            borderRadius: '4px',
            width: '200px',
            padding: 1
          },
        }}
        MenuListProps={{
          sx: {
            backgroundColor: 'background',
          },
        }}
      >
        <MhdSelect
          label="DPI"
          value={data.plot_widget.dpi}
          override={mods.plot_widget.dpi}
          onChange={useCallback((v) => setAndUpdate("dpi", v, setter, update), [])}
          choices={resolutionChoices}
        />
      </Menu>

      <Stack direction={'row-reverse'} pt={1} pr={1} pl={1} alignItems={'center'} spacing={1}>
        <Tooltip title="Reset Values" arrow>
          <IconButton
            onClick={resetDefaults}
            variant={'toolbar'}
            color={'primary'}
          >
            <RestartAlt />
          </IconButton>
        </Tooltip>

        <Tooltip title="Set Resolution" arrow>
          <IconButton
            onClick={(e) => setResolutionAnchor(e.currentTarget)}
            variant={'toolbar'}
            color={'primary'}
          >
            <HighQuality />
          </IconButton>
        </Tooltip>
        <Tooltip title="Download Image (JPG)" arrow>
          <IconButton
            onClick={useCallback(() => downloadImage(tool, `${meta?.image}` ?? ''), [meta])}
            variant={'toolbar'}
            color={'primary'}
            disabled={Boolean(error) || loading || awaitingApi}
          >
            <Download />
          </IconButton>
        </Tooltip>
        <Tooltip title={`Download Data (${toolExtensionCoupling[tool]})`} arrow>
          <IconButton
            onClick={useCallback(() => downloadData(tool, meta?.key_id, toolExtensionCoupling[tool], setAwaitingApi), [tool, meta])}
            variant={'toolbar'}
            color={'primary'}
            disabled={Boolean(error) || loading || awaitingApi}
          >
            <Code />
          </IconButton>
        </Tooltip>
        {hasAsciiTable.includes(tool) && (
          <Tooltip title={`Download ASCII (DAT)`} arrow>
            <IconButton
              onClick={useCallback(() => downloadData(tool, meta?.key_id, 'DAT', setAwaitingApi), [tool, meta])}
              variant={'toolbar'}
              color={'primary'}
              disabled={Boolean(error) || loading || awaitingApi}
            >
              <Description />
            </IconButton>
          </Tooltip>
        )}

        <Box sx={{ flexGrow: 1}} />
        { toolTutorialLinks[tool] && (
          <Tooltip title="View Tutorial" arrow>
            <IconButton
              component="a"
              href={toolTutorialLinks[tool]}
              target="_blank"
              rel="noopener noreferrer"
              variant={'toolbar'}
              color={'primary'}
            >
              <YouTube />
            </IconButton>
          </Tooltip>
        )}
      </Stack>
      {awaitingApi && (
        <Box display="flex" justifyContent="center">
          <LinearProgress sx={{ width: '100%', marginX: '10px' }} />
        </Box>
      )}
      </Box>
  );
}

export default PlotOptionsBar;